import axios from '@/libs/api.request'

// 获取消息列表
export const getNotificationList = (params) => {
  return axios.request({
    url: 'notifications/list',
    method: 'post',
    data: params
  })
}

// 获取未读消息数量
export const getUnreadCount = () => {
  return axios.request({
    url: 'notifications/unread-count',
    method: 'get'
  })
}

// 标记消息为已读
export const markAsRead = (ids) => {
  return axios.request({
    url: 'notifications/mark-read',
    method: 'post',
    data: { ids }
  })
}

// 标记所有消息为已读
export const markAllAsRead = () => {
  return axios.request({
    url: 'notifications/mark-all-read',
    method: 'post'
  })
}

// 删除消息
export const deleteNotification = (ids) => {
  return axios.request({
    url: 'notifications/delete',
    method: 'post',
    data: { ids }
  })
}

// 获取消息详情
export const getNotificationDetail = (id) => {
  return axios.request({
    url: `notifications/${id}`,
    method: 'get'
  })
}

// 获取系统公告列表
export const getAnnouncementList = (params) => {
  return axios.request({
    url: 'notifications/announcements',
    method: 'post',
    data: params
  })
}

// 获取告警列表
export const getAlertList = (params) => {
  return axios.request({
    url: 'notifications/alerts',
    method: 'post',
    data: params
  })
}

// 处理告警
export const handleAlert = (id, action, remark) => {
  return axios.request({
    url: 'notifications/alerts/handle',
    method: 'post',
    data: { id, action, remark }
  })
}

